import type { SVGProps } from 'react'
const SvgSyTetherGold = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 141.7 141.7" width={24} height={24} {...props}>
		<path d="M84.7 75.5c-.8 0-4.8.3-13.7.3s-12.1-.2-13.9-.3c-27.4-1.2-47.8-6-47.8-11.7s20.4-10.5 47.8-11.7v18.6c1.8.1 6.9.5 14 .5s12.8-.4 13.5-.5V52.1c27.3 1.2 47.7 6 47.7 11.7s-20.4 10.5-47.7 11.7zm0-25.2V33.6h38.1V8.1H19v25.4h38.1v16.7c-31 1.4-54.3 7.5-54.3 14.9S26.1 78.6 57.1 80v53.4h27.6V80c30.9-1.4 54.2-7.5 54.2-14.9s-23.3-13.6-54.2-15z" />
	</svg>
)
export default SvgSyTetherGold
